import type { ChildControls, ParentPreset } from "./parentTypes";

export const RECOMMENDED_CHILD_CONTROLS: Readonly<ChildControls> = Object.freeze({
  allowNewDrawings: true,
  allowNewComics: true,
  allowActivities: true,
  allowProjectDeletion: false,
  allowBackupImport: false,
  allowBackupExport: false,
  studioToolLevel: "creative",
  allowDestructiveEditing: false,
});

export const FULL_ACCESS_CONTROLS: Readonly<ChildControls> = Object.freeze({
  allowNewDrawings: true,
  allowNewComics: true,
  allowActivities: true,
  allowProjectDeletion: true,
  allowBackupImport: true,
  allowBackupExport: true,
  studioToolLevel: "full",
  allowDestructiveEditing: true,
});

export function controlsForPreset(preset: Exclude<ParentPreset, "custom">): ChildControls {
  return {
    ...(preset === "recommended" ? RECOMMENDED_CHILD_CONTROLS : FULL_ACCESS_CONTROLS),
  };
}

export function identifyPreset(controls: ChildControls): ParentPreset {
  const entries = Object.keys(controls) as Array<keyof ChildControls>;
  if (entries.every((key) => controls[key] === RECOMMENDED_CHILD_CONTROLS[key])) {
    return "recommended";
  }
  if (entries.every((key) => controls[key] === FULL_ACCESS_CONTROLS[key])) return "full";
  return "custom";
}
